import { type ReactNode } from 'react'
import styles from './AccountView.module.css'
import {
  ScreenHeaderProvider,
  ScreenHeaderContent,
  ScreenHeaderMain,
  ScreenHeaderTitle,
} from '@/components/ScreenHeader'

interface AccountViewCompactLayoutProps {
  avatar?: ReactNode
  children?: ReactNode
}

export function AccountViewCompactLayout({
  avatar,
  children,
}: AccountViewCompactLayoutProps) {
  return (
    <>
      <ScreenHeaderProvider scrollFading="off" isOverlay>
        <ScreenHeaderMain>
          <ScreenHeaderContent>
            <div className={styles.headerContainer}>
              <header className={styles.header}>
                <ScreenHeaderTitle>
                  <div className={styles.headerAvatar}>{avatar}</div>
                  <h1 className={styles.title}>Account</h1>
                  <h2 className={styles.subtitle}>
                    Manage your account settings
                  </h2>
                </ScreenHeaderTitle>
              </header>
            </div>
          </ScreenHeaderContent>
        </ScreenHeaderMain>
      </ScreenHeaderProvider>
      <div className="mx-md mb-2xl flex flex-col gap-2xl">{children}</div>
    </>
  )
}

interface AccountViewSpaciousLayoutProps {
  navigation: ReactNode
  children: ReactNode
}

export function AccountViewSpaciousLayout({
  navigation,
  children,
}: AccountViewSpaciousLayoutProps) {
  return (
    <div className="px-7xl pb-5xl">
      <div className={styles.columns}>
        <div className={styles.navColumn}>
          <div className={styles.sticky}>
            <div className={styles.headerContainer}>
              <header className={styles.header}>
                <h1 className={styles.title}>Account</h1>
                <h2 className={styles.subtitle}>
                  Manage your account settings
                </h2>
              </header>
            </div>
            <div className="pb-7xl pt-lg flex flex-col gap-7xl">
              {navigation}
            </div>
            <div className="pb-2xl" />
          </div>
        </div>

        <div className={styles.detailsColumn}>
          <div className={styles.gradient} aria-hidden />
          {children}
        </div>
      </div>
    </div>
  )
}
